import * as React from 'react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import enLocale from 'date-fns/locale/en-GB';
import huLocale from 'date-fns/locale/hu';
import deLocale from 'date-fns/locale/de';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LANGUAGE } from '../i18n';

const localeMap = {
  en: enLocale,
  hu: huLocale,
  de: deLocale
};

const DatePickerProvider = ({ children }) => {
  const { i18n } = useTranslation();

  return (
    <MuiPickersUtilsProvider
      utils={ DateFnsUtils }
      locale={ localeMap[i18n.language] ?? localeMap[DEFAULT_LANGUAGE] }
    >
      {children}
    </MuiPickersUtilsProvider>
  );
};

export default DatePickerProvider;
